import Mustache from "mustache";

export class ConfirmDialog {
	constructor(form) {
		this.form = form;
		const subwrap = this.form.querySelector(".submit-button-wrapper");

		// Only proceed if the confirm dialog is actually configured
		if (!subwrap?.dataset.dtbConfirmDialog) {
			return;
		}

		this.config = JSON.parse(atob(subwrap.dataset.dtbConfirmDialog));
		this._confirmed = false;
		this.createDialog();
		this.init();
	}

	createDialog() {
		this.dialog = document.createElement("dialog");
		this.dialog.className = "dtb-confirm-dialog";

		// Create placeholders for live text rendering.
		this.dialog.innerHTML = `
      <p></p>
      <div>
        <button type="button" class="dtb-confirm-button"></button>
        <button type="button" class="dtb-cancel-button">Cancel</button>
      </div>
    `;

		document.body.appendChild(this.dialog);

		// Confirm button handler.
		this.dialog
			.querySelector(".dtb-confirm-button")
			.addEventListener("click", () => {
				this._confirmed = true;
				this.dialog.close();
				const submitButton = this.form.querySelector(
					'button[type="submit"]',
				);
				if (submitButton) {
					submitButton.click();
				} else {
					this.form.dispatchEvent(
						new Event("submit", {
							bubbles: true,
							cancelable: true,
						}),
					);
				}
			});

		// Cancel button handler.
		this.dialog
			.querySelector(".dtb-cancel-button")
			.addEventListener("click", () => {
				this.dialog.close();
			});

		// Close dialog when cancelled via other means.
		this.dialog.addEventListener("cancel", () => {
			this.dialog.close();
		});
	}

	// This method renders live text into the dialog using current form data.
	render() {
		// Gather current form data into an object.
		const fd = new FormData(this.form);
		const data = {};
		fd.forEach((value, key) => {
			data[key] = value;
		});
		// Render the text templates via Mustache.
		const confirmText = Mustache.render(
			this.config.confirm_text || "Are you sure you want to submit?",
			{ form: data },
		);
		const confirmButtonText = Mustache.render(
			this.config.confirm_button || "Confirm",
			{ form: data },
		);

		// Update the dialog's content.
		const p = this.dialog.querySelector("p");
		if (p) {
			p.innerHTML = confirmText;
		}
		const confirmButton = this.dialog.querySelector(".dtb-confirm-button");
		if (confirmButton) {
			confirmButton.innerHTML = confirmButtonText;
		}
	}

	init() {
		// Update live content on every form input change.
		this.form.addEventListener("input", () => this.render());

		// Intercept the form submit to show the dialog.
		this.form.addEventListener(
			"submit",
			(e) => {
				if (this._confirmed) {
					// Reset for future submissions.
					this._confirmed = false;
					return;
				}
				e.preventDefault();
				e.stopImmediatePropagation();
				// Make sure the dialog content is up to date.
				this.render();
				this.dialog.showModal();
			},
			true,
		); // Use capture phase to intercept before other listeners.
	}
}
